<template>
    <v-row v-if="useIsLoadingHotelInfo" dense>
        <v-sheet class="full-width d-flex justify-center py-2">
            <v-progress-linear color="primary" indeterminate class="mb-0" height="3px" />
        </v-sheet>
    </v-row>
    <SecondLevelTabs :tabs="secondLevelInfoTabs" translation-key="product_tabs">
        <template v-slot:details>
            <ProductHotelDetailsDescriptionForm v-if="!useIsLoadingHotelInfo" />
        </template>
        <template v-slot:general>
            <ProductHotelGeneralDescriptionForm />
        </template>
        <template v-slot:amenities>
            <ProductHotelAmenitiesDescriptionForm v-if="!useIsLoadingHotelInfo" />
        </template>
        <template v-slot:location>
            <ProductHotelLocationDescription />
        </template>
        <template v-slot:check_in>
            <CheckInForm />
        </template>
    </SecondLevelTabs>
</template>
<script setup lang="ts">
    import CheckInForm from '~/components/products/hotels/CheckInForm.vue'
    import ProductHotelGeneralDescriptionForm from './ProductHotelGeneralDescriptionForm.vue'
    import ProductHotelDetailsDescriptionForm from './ProductHotelDetailsDescriptionForm.vue'
    import ProductHotelLocationDescription from '~src/components/products/hotels/ProductHotelLocationDescription.vue'
    import ProductHotelAmenitiesDescriptionForm from '~src/components/products/hotels/ProductHotelAmenitiesDescriptionForm.vue'

    // Tab order: Details (preselected) → Sustainability Information → Amenities → Location → Check In
    const secondLevelInfoTabs = ['details', 'general', 'amenities', 'location', 'check_in']

    onMounted(async () => {
        if (!supplierStore.fullContract?.id) await loadData()
    })

    async function loadData(): Promise<void> {
        await supplierStore.loadFullContract()
    }
</script>
